import type { User } from '@metadevprofile/shared';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/common/redux/store';

export interface AuthState {
  user: User | null;
  loading: boolean;
  mfaToken: string | null;
}

const initialState: AuthState = {
  user: null,
  loading: false,
  mfaToken: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
    setMfaToken: (state, action: PayloadAction<string | null>) => {
      state.mfaToken = action.payload;
    },
    resetAuth: () => initialState,
  },
});

export const { setAuthLoading, setUser, setMfaToken, resetAuth } = authSlice.actions;
export const authReducer = authSlice.reducer;

export const selectUser = (state: RootState): User | null => state.auth.user;
export const selectAuthLoading = (state: RootState): boolean => state.auth.loading;
export const selectMfaToken = (state: RootState): string | null => state.auth.mfaToken;
